import Modal from 'react-bootstrap/Modal';
import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";
import { TitleH3 } from "../../../components/TitleH3";

import correct_img from '../../../assets/images/questions/correct.svg'
import missing_img from '../../../assets/images/questions/missing.svg'
import wrong_img from '../../../assets/images/questions/wrong.svg'
import score_img from '../assets/images/score.svg'
import structure_img from '../assets/images/structure.svg'
import { Button } from '../../../components/Button';
import { formatScore } from "../examUtils";

export default function ExamResultsModal({show, examData = {}, handleClose}) {

    const t = useSelector(selectTranslations)

    const onCloseModal = () => {
        handleClose();
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                centered
            >
                <div className="modal-content py-4">
                    <div style={{maxWidth:"500px", minWidth:"320px"}} className="mx-auto">
    
                        {
                            examData?.thresholds?.some(m => m?.is_showable) &&
                            <div className="border mt-3 mb-2 p-3 pt-4" style={{borderRadius:"16px", background:'#FFFDFC'}}>
                                <TitleH3 className="text-center"><img src={structure_img} alt="" className="me-2"/>{t.exam.modules}</TitleH3>
                                {examData?.thresholds?.map((m,i)=>{
                                    if(m?.is_showable)
                                        return(
                                            <div className="mb-2" key={i}>
                                                <span>{m.threshold_name}</span>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>min {formatScore(m?.score)} {t.exam.pt}</span>
                                                    <span>{m?.has_been_passed ? <span className="text-success">{t.ofa.scoring.passed}</span> : <span className="text-danger">{t.ofa.scoring.not_passed}</span>}</span>
                                                </div>
                                                <hr />
                                            </div>
                                        )
                                    else
                                        return null
                                }
                                    )
                                }
                            </div>
                        }
                    </div>
                    <div className="d-flex justify-content-center ">
                        <Button id="closeModalButton" onClick={onCloseModal} className="white">
                            {t.buttons.close}
                        </Button>

                    </div>
                    
                </div>
            </Modal>
        </>
    );
}